import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	placeholderContainer: {
		padding: theme.spacing.medium,
		backgroundColor: theme.palette.neutral[10],
		borderRadius: theme.borderRadius.rounded,
		color: theme.palette.neutral[50],
		textAlign: 'center',

		[getFromBreakpoint('md')]: {
			padding: theme.spacing.xlarge,
		},
	},
}));
